export const REACT_APP_API_URL = process.env.REACT_APP_API_URL;
export const APP_LANGUAGES = JSON.parse(process.env.REACT_APP_LANGUAGES);
